module.exports = __webpack_public_path__ + "static/media/A_iko_2_strzalka_dol_active.dcd9fdc1.svg";